import Events from "@wwdev/bootstrap/Events";

class Indicator {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-indicator="scope"]',
			input: '[data-indicator="input"]',
			remove: '[data-indicator="remove"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			$(document).off('.indicator').on('click.indicator', '.winkelwagen-indicator', this.toggleWinkelwagenView.bind(this));

			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		Events.on('wwdev.reload.indicator', this.reloadIndicator.bind(this));
		this.$scope.on('change', this.config.input, this.updateQuantity.bind(this));
		this.$scope.on('click', this.config.remove, this.removeItem.bind(this));
	}

	updateQuantity(e) {
		let $input = $(e.currentTarget);
		$.ajax({
			url: $input.attr("data-href"),
			method: "post",
			data: {
				productId: $input.attr("data-id"),
				quantity: $input.val(),
				action: "update_product_quantity",
				source: "indicator",
			},
			success: this._onSuccess.bind(this)
		});
	}

	reloadIndicator() {
		$.ajax({
			url: this.$scope.attr("data-href"),
			method: "post",
			data: {
				action: "get_indicator",
				source: "indicator",
			},
			success: this._onSuccess.bind(this)
		});
	}

	removeItem(e) {
		let $input = $(e.currentTarget);

		if (confirm("Weet u het zeker?")) {
			$.ajax({
				url: $input.attr("data-href"),
				method: "post",
				data: {
					productId: $input.attr("data-id"),
					action: "remove_product",
					source: "indicator",
				},
				success: this._onSuccess.bind(this)
			});
		}
	}

	_onSuccess(response) {
		this.$scope.html(response.indicator);
		let $indicator = this.$scope.find('.winkelwagen-overview');

		if ($indicator.data('open') == false) {
			this._open($indicator);
		}
		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			if ($indicator.data('open') == true) {
				this._close($indicator);
			}
		}, 2000);
	}

	toggleWinkelwagenView(event) {
		event.preventDefault();
		let $target = $(event.currentTarget);
		let $indicator = $target.closest('.winkelwagen-wrapper').find('.winkelwagen-overview');

		if ($indicator.data('open') == false) {
			this._open($indicator);
		} else {
			this._close($indicator);
		}
	}

	_open($indicator) {
		$indicator.slideDown()
		$indicator.data('open', true);
	}

	_close($indicator) {
		$indicator.slideUp()
		$indicator.data('open', false);
	}
}

new Indicator();